import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import GridItem from "@insite/mobius/GridItem/GridItem";
import Typography from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    discountinuedCheck: ownProps.productInfo.inventory?.additionalResults?.isDiscontinued,
});

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
    discontinuedInfoGridItem?: InjectableCss;
    discontinuedInfoMessage?: InjectableCss;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
        `,
    },
    discontinuedInfoGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            padding-top: 20px;
        `,
    },
    discontinuedInfoMessage: {
        css: css`
            color: red;
        `,
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink = ({ product, variantSelectionCompleted, discountinuedCheck }: OwnProps) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }

    const isDiscontinuedMessage = discountinuedCheck !== null && discountinuedCheck?.toUpperCase() === "TRUE";

    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductAddToListLink data-test-selector="productDetails_addToList" extendedStyles={styles.link} />
            {isDiscontinuedMessage && (
                <GridItem {...styles.discontinuedInfoGridItem}>
                    <Typography {...styles.discontinuedInfoMessage} as="p">
                        {siteMessage("DiscontinuedInfo_Message")}
                    </Typography>
                </GridItem>
            )}
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsAddToListLink)),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};
export default widgetModule;
